import { isOwner, projectStatusByCode, taskStatusByCode } from 'entities';

import { UserPlusIcon } from 'components/Icons';

import { registerTaskOption } from '../options';

import { RequestRecruitmentModal } from './RequestRecruitmentModal';

export default registerTaskOption({
  Icon: UserPlusIcon,

  getLabel: (t) => t('request-recruitment'),

  modal: 'REQUEST_RECRUITMENT',
  overlay: RequestRecruitmentModal,

  shortcutKey: 'R',

  useOption: ({ task, openModal, loggedUser, project }) => {
    const isEnabled = [
      isOwner(task, loggedUser),
      !!task.canCreateSampleProject,
      loggedUser.sampleId,
      projectStatusByCode[project.status].isActiveStatus,
      taskStatusByCode[task.status].canRequestRecruitment,
      taskStatusByCode[task.status].isActiveStatus,
    ].every(Boolean);

    return {
      action: () => openModal('REQUEST_RECRUITMENT'),
      isEnabled,
    };
  },
});
